import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ControlPanelPage } from './control-panel';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		ControlPanelPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(ControlPanelPage),
	],
})
export class ControlPanelPageModule {}



// WEBPACK FOOTER //
// ./src/pages/control-panel/control-panel.module.ts